<template>
  <v-row dense>
    <v-col cols="12">
      <h4 class="overline">Contact Information from Institution</h4>

      <v-divider class="mb-3" />
    </v-col>

    <v-col cols="12" sm="6" md="4">
      <v-text-field
        dense
        outlined
        ref="ContactPerson"
        :value="value.ContactPerson"
        :rules="rules.ContactPerson"
        @input="update('ContactPerson', $event)"
      >
        <template #label>
          <div>
            Contact Person
            <span class="red--text">*</span>
          </div>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" sm="6" md="4">
      <v-text-field
        dense
        outlined
        ref="ContactDesignation"
        :value="value.ContactDesignation"
        :rules="rules.ContactDesignation"
        @input="update('ContactDesignation', $event)"
      >
        <template #label>
          <div>
            Designation
            <span class="red--text">*</span>
          </div>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" sm="6" md="4">
      <v-select
        dense
        outlined
        ref="ContactCountry"
        :value="value.ContactCountry"
        :items="countries"
        item-text="displayName"
        item-value="code"
        :rules="rules.ContactCountry"
        @input="update('ContactCountry', $event)"
      >
        <template #label>
          <div>
            Country
            <span class="red--text">*</span>
          </div>
        </template>
      </v-select>
    </v-col>

    <v-col cols="12" sm="6" md="4">
      <v-text-field
        dense
        outlined
        ref="ContactEmail"
        :value="value.ContactEmail"
        :rules="rules.ContactEmail"
        @input="update('ContactEmail', $event)"
      >
        <template #label>
          <div>
            Email Address
            <span class="red--text">*</span>
          </div>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" sm="6" md="8">
      <v-text-field
        dense
        outlined
        ref="contactPersonAddress"
        :value="value.contactPersonAddress"
        :rules="rules.contactPersonAddress"
        @input="update('contactPersonAddress', $event)"
      >
        <template #label>
          <div>
            Address
            <span class="red--text">*</span>
          </div>
        </template>
      </v-text-field>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ForeignContactSection",

  model: {
    prop: "value",
    event: "input",
  },

  props: {
    value: {
      type: Object,
      required: true,
    },

    rules: {
      type: Object,
      required: true,
    },

    countries: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    update(field, value) {
      this.$emit("input", {
        ...this.value,
        [field]: typeof value === "string" ? value.toUpperCase() : value,
      });
    },

    validate() {
      return Object.values(this.$refs).every((ref) => {
        return typeof ref.validate === "function" ? ref.validate(true) : true;
      });
    },

    resetValidation() {
      Object.values(this.$refs).forEach((ref) => {
        if (typeof ref.resetValidation === "function") {
          ref.resetValidation();
        }
      });
    },
  },
};
</script>
